import { FC, useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import InputText from '../InputText';
import Button from '../Buttons';

type SearchModuleProps = {
  placeholder: string;
  onSearch: (searchTerm: string) => void; // eslint-disable-line
};

const SearchModule: FC<SearchModuleProps> = ({ placeholder, onSearch }) => {
  const { t } = useTranslate();
  const [searchTerm, setSearchTerm] = useState('');

  const isSearchButtonDisabled = searchTerm === '';

  const handleChangeSearchTerm = (value: string) => {
    setSearchTerm(value);
    if (value === '') {
      onSearch('');
    }
  };

  const handleSearch = () => {
    onSearch(searchTerm);
  };

  return (
    <div className="card-bordered p-2 d-flex justify-content-between w-100">
      <div id="searchModule" className="form-group flex-fill mb-0 mr-1">
        <InputText
          id="cif"
          label=""
          value={searchTerm}
          icon="ni-search"
          placeholder={placeholder}
          onChange={handleChangeSearchTerm}
          isClearable
        />
      </div>

      <Button onClick={handleSearch} disabled={isSearchButtonDisabled}>
        {t('SearchTitle')}
      </Button>
    </div>
  );
};

export default SearchModule;
